module.exports = __webpack_public_path__ + "static/media/XOR.177ba1c4.svg";